import { Check, MonitorUp, X } from "lucide-react";

export function MirrorSentModal({ party, onOpenCustomer, onClose }) {
  return <div className="modal-backdrop" data-testid="mirror-sent-modal"><div className="modal">
    <button className="modal-close" onClick={onClose}><X size={18} /></button>
    <div className="modal-icon blue"><MonitorUp size={22} /></div>
    <span className="eyebrow">SCREEN MIRROR</span>
    <h2>Request sent to {party.name.split(" ")[0]}.</h2>
    <p>{party.name.split(" ")[0]} will see a prompt on their portal. Once they accept, their live screen appears here so you can guide them step by step.</p>
    <button className="primary-btn full" onClick={onOpenCustomer} data-testid="mirror-open-customer-button">Open customer view to accept (demo) <Check size={15} /></button>
    <button className="quiet-btn" onClick={onClose} data-testid="mirror-sent-close">I'll wait here</button>
  </div></div>;
}

export function MirrorRequestModal({ party, onAccept, onDecline }) {
  return <div className="modal-backdrop" data-testid="mirror-request-modal"><div className="modal">
    <div className="modal-icon blue"><MonitorUp size={22} /></div>
    <span className="eyebrow">SCREEN SHARE REQUEST</span>
    <h2>Priya Sharma wants to view your screen.</h2>
    <p>Your loan officer is offering to help you navigate. <strong>Only this portal is shared</strong> — never your other apps — and you can stop anytime.</p>
    <button className="primary-btn full" onClick={onAccept} data-testid="mirror-accept-button">Accept & share screen <Check size={15} /></button>
    <button className="quiet-btn" onClick={onDecline} data-testid="mirror-decline-button">Decline</button>
  </div></div>;
}

export function MirrorPanel({ party, onEnd }) {
  return <div className="mirror-panel" data-testid="mirror-panel">
    <div className="mirror-live"><i></i> LIVE — {party.name.split(" ")[0].toUpperCase()}'S SCREEN <button className="mini-btn" style={{ marginLeft: "auto" }} onClick={onEnd} data-testid="mirror-end-button">End</button></div>
    <div className="mirror-screen">
      <b style={{ color: "#fff", fontSize: 11 }}>Student portal · Documents & Verify</b>
      <div className="mini-bar" style={{ width: "68%" }}></div>
      <div className="mini-bar" style={{ width: "84%" }}></div>
      <div className="mini-bar" style={{ width: "52%" }}></div>
      <span>Viewing in real time · demo simulation</span>
    </div>
    <span style={{ fontSize: 10, color: "#9db1c2" }}>Guide {party.name.split(" ")[0]} over the phone while you watch their screen.</span>
  </div>;
}

export function MirrorBanner({ onStop }) {
  return <div className="mirror-banner" data-testid="mirror-banner">
    <span className="mirror-live"><i></i> Sharing your screen with Priya Sharma (loan officer)</span>
    <button className="mini-btn" onClick={onStop} data-testid="mirror-stop-button">Stop sharing</button>
  </div>;
}
